const getImageSrc = (item) => {
  //   console.log("getImageSrc");
  //   console.log(item);
  if (item.apiItem) {
    return item.path;
  } else if (item?.previousEntryItem) {
    return URL.createObjectURL(item.file);
  } else {
    return URL.createObjectURL(item);
  }
};

const handleImageLoad = ({ imageElement, setItemLoading }) => {
  //   console.log("handleImageLoad");
  if (imageElement && imageElement.src.startsWith("blob:")) {
    URL.revokeObjectURL(imageElement.src);
  }

  if (typeof setItemLoading === "function") {
    setItemLoading();
  }
};

export { getImageSrc, handleImageLoad };
